import {
  Box,
  Center,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from "@chakra-ui/react";
import Link from "next/link";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { GetCookie } from "../../provider/common";

export default function MypageNavigation() {
  const { pathname } = useRouter();
  const axios = require("axios").default;
  const router = useRouter();
  const [sellerPageState, setSellePageStage] = useState("");

  useEffect(() => {
    // 현재 판매자 페이지 상태값을 따로 저장한다.
    changeSellerPageState();
  }, []);

  const checkApproved = async () => {
    const approvedApi = process.env.PANDA_API_URL + "/api/auth/sellerDecode";
    const token = await GetCookie("token");
    const approvedRes = await axios.post(
      approvedApi,
      {
        token: token,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );

    const approvedCondition = approvedRes.data.data;
    if (approvedCondition === "not_login") {
      alert("로그인 후 이용해주세요.");
      const href = `/auth/login`;
      router.push(href);
      return;
    } else if (approvedCondition === "submitted") {
      alert("승인 대기중입니다.\n영업일 기준 1일내로 연락드리겠습니다.");
      return;
    } else if (approvedCondition === "not_approved") {
      const href = "/board/register";
      router.push(href);
      return;
    } else if (approvedCondition === "approved") {
      const href = "/seller/dashboard";
      router.push(href);
      return;
    }
  };

  const changeSellerPageState = async () => {
    const approvedApi = process.env.PANDA_API_URL + "/api/auth/sellerDecode";
    const token = await GetCookie("token");
    const approvedRes = await axios.post(
      approvedApi,
      {
        token: token,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );

    const approvedCondition = approvedRes.data.data;
    if (approvedCondition === "not_login") {
      setSellePageStage("판매자신청");
    } else if (approvedCondition === "submitted") {
      setSellePageStage("판매자페이지");
    } else if (approvedCondition === "not_approved") {
      setSellePageStage("판매자신청");
    } else if (approvedCondition === "approved") {
      setSellePageStage("판매자페이지");
    }
  };

  return (
    <Center w="200px" h="130px" bg="#E53E3E" className="parent">
      <Breadcrumb
        fontWeight="medium"
        fontSize="sm"
        mt="1"
        paddingBottom="4"
        className="children "
      >
        <BreadcrumbItem>
          <BreadcrumbLink href="/">Home</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink href="/mypage/orders">마이페이지</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage color="#E53E3E" fontWeight="bold">
          <BreadcrumbLink>
            {pathname === "/mypage/info"
              ? "회원정보 수정"
              : pathname === "/mypage/orders"
              ? "주문내역"
              : pathname === "/mypage/coupon"
              ? "쿠폰"
              : pathname === "/mypage/point"
              ? "포인트"
              : pathname === "/mypage/wishlist"
              ? "찜리스트"
              : pathname === "/mypage/shipping"
              ? "배송지 관리"
              : null}
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Heading as="h4" size="md" color="white" letterSpacing="-1px">
        마이페이지
      </Heading>
      <Box className="layout-category flex-center center-nav">
        <Box className="layout__category-box">
          <Link href="/mypage/info" passHref>
            <span
              className={[
                "cursor",
                pathname === "/mypage/info" ? "clicked" : null,
              ].join(" ")}
            >
              회원정보 수정
            </span>
          </Link>
          <span className={["cursor"].join(" ")} onClick={checkApproved}>
            {sellerPageState}
          </span>
          <Link href="/mypage/orders" passHref>
            <span
              className={[
                "cursor",
                pathname === "/mypage/orders" ? "clicked" : null,
              ].join(" ")}
            >
              주문내역
            </span>
          </Link>
          <Link href="/mypage/shipping" passHref>
            <span
              className={[
                "cursor",
                pathname === "/mypage/shipping" ? "clicked" : null,
              ].join(" ")}
            >
              배송지 관리
            </span>
          </Link>
          <Link href="/mypage/coupon" passHref>
            <span
              className={[
                "cursor",
                pathname === "/mypage/coupon" ? "clicked" : null,
              ].join(" ")}
            >
              쿠폰
            </span>
          </Link>
          <Link href="/mypage/point" passHref>
            <span
              className={[
                "cursor",
                pathname === "/mypage/point" ? "clicked" : null,
              ].join(" ")}
            >
              포인트
            </span>
          </Link>
          <Link href="/mypage/wishlist" passHref>
            <span
              className={[
                "cursor",
                pathname === "/mypage/wishlist" ? "clicked" : null,
              ].join(" ")}
            >
              찜리스트
            </span>
          </Link>
          <Link href="/estimate/lists" passHref>
            <span className={"cursor"}>견적내역</span>
          </Link>
        </Box>
      </Box>
    </Center>
  );
}
